export class FirebaseUserModel {
  image: string;
  name: string;
  provider: string;

  constructor(){
    this.image = "";
    this.name = "";
    this.provider = "";
  }
}

export interface User {
  email: string,
  uid: string,
  authenticated: boolean
}

export interface UserInfo {
	country: string,
	name: string,
	phone: string,
	second_name: string,
  photoUrl: string
}


